import { render, staticRenderFns } from "./ValidateDomainPopup.vue?vue&type=template&id=20c44946&scoped=true"
import script from "./ValidateDomainPopup.vue?vue&type=script&lang=js"
export * from "./ValidateDomainPopup.vue?vue&type=script&lang=js"
import style0 from "./ValidateDomainPopup.vue?vue&type=style&index=0&id=20c44946&prod&lang=scss&scoped=true"
import style1 from "./ValidateDomainPopup.vue?vue&type=style&index=1&id=20c44946&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c44946",
  null
  
)

export default component.exports